module.exports = __webpack_public_path__ + "img/Poorter_hotel-533-HDR.43228c78.jpg";